// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  ServiceType,
  ServiceStatus,
} from "./types";


export default __t.row({
  id: __t.u32().primaryKey(),
  name: __t.string(),
  get serviceType() {
    return ServiceType.name("service_type");
  },
  get status() {
    return ServiceStatus;
  },
  description: __t.string(),
  projectId: __t.u32().name("project_id"),
  tokenId: __t.option(__t.u32()).name("token_id"),
  identityHex: __t.string().name("identity_hex"),
  targetModules: __t.string().name("target_modules"),
  lastSeenAt: __t.option(__t.timestamp()).name("last_seen_at"),
  createdBy: __t.identity().name("created_by"),
  createdAt: __t.timestamp().name("created_at"),
  updatedAt: __t.timestamp().name("updated_at"),
  healthJson: __t.option(__t.string()).name("health_json"),
  displayName: __t.option(__t.string()).name("display_name"),
  envKeyNames: __t.option(__t.string()).name("env_key_names"),
});
